import { Group } from "konva/lib/Core";
import { IWhiteboardLinkState } from ".";

export interface ILink<State extends IWhiteboardLinkState> {
  link: State;
  connectShapes(source: Group, target: Group): void;
}

export abstract class WhiteboardLink<State extends IWhiteboardLinkState = IWhiteboardLinkState> extends Group implements ILink<State> {
  constructor(public link: State) {
    super();
  }

  abstract connectShapes(source: Group, target: Group): void;
}
